module.exports = __webpack_public_path__ + "img/quote-blue.2e60cba9.svg";